$(document).ready(function() {
    var $videoItem = $('.ttg-bilder-carousel.slick-slider .ttg-carousel-item.youtube');
    var $firstItem = $('.ttg-bilder-carousel.slick-slider .ttg-carousel-item').first();

    if ($videoItem.length && $firstItem.length) {
        $videoItem.insertAfter($firstItem);
    }
});